module.exports = __webpack_public_path__ + "img/20191006112215506.9404bca4.jpg";